import { render, staticRenderFns } from "./StepTabQuestions.vue?vue&type=template&id=7ad1302e&scoped=true"
import script from "./StepTabQuestions.vue?vue&type=script&lang=js"
export * from "./StepTabQuestions.vue?vue&type=script&lang=js"
import style0 from "./StepTabQuestions.vue?vue&type=style&index=0&id=7ad1302e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad1302e",
  null
  
)

export default component.exports